import { render, staticRenderFns } from "./calyrafit-marquee-01.vue?vue&type=template&id=44bbc526&scoped=true&"
import script from "./calyrafit-marquee-01.vue?vue&type=script&lang=js&"
export * from "./calyrafit-marquee-01.vue?vue&type=script&lang=js&"
import style0 from "./calyrafit-marquee-01.vue?vue&type=style&index=0&id=44bbc526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bbc526",
  null
  
)

export default component.exports